(function () {
  const DRAWER_SEL = '.cart-drawer, [data-cart-drawer], .mini-cart, [data-mini-cart]';
  const CHECKOUT_SEL = '#checkout, button[name="checkout"], .cart__checkout, [data-checkout-button], a[href="/checkout"]';
  const CHECKBOX_SEL = '#accept-terms, #accept-privacy, #accept-adult, .cart__terms-checkbox';

  function scopeEl() {
    return document.querySelector(DRAWER_SEL) || document;
  }

  function findCheckout() {
    const scope = scopeEl();
    return scope.querySelector(CHECKOUT_SEL) || document.querySelector(CHECKOUT_SEL);
  }

  function getRequiredCheckboxes() {
    const scope = scopeEl();
    return Array.from(scope.querySelectorAll(CHECKBOX_SEL));
  }

  function allChecked() {
    const cbs = getRequiredCheckboxes();
    if (cbs.length === 0) return false;
    return cbs.every(cb => cb.checked);
  }

  function disableAnchorLike(btn, disabled) {
    if (!btn) return;
    const isAnchor = btn.tagName === 'A';
    if (isAnchor) {
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-disabled');
        btn.setAttribute('tabindex', '-1');
        btn.style.pointerEvents = 'none';
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-disabled');
        btn.removeAttribute('tabindex');
        btn.style.pointerEvents = '';
      }
    } else {
      btn.disabled = disabled;
      if (disabled) btn.classList.add('is-disabled'); else btn.classList.remove('is-disabled');
    }
  }

  function updateCheckoutState() {
    const btn = findCheckout();
    if (!btn) return;
    const disabled = !allChecked();
    disableAnchorLike(btn, disabled);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches(CHECKBOX_SEL)) updateCheckoutState();
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest(CHECKOUT_SEL);
    if (!btn) return;
    if (!allChecked()) {
      e.preventDefault();
      e.stopPropagation();
      updateCheckoutState();
    }
  }, true);

  const observerRoot = document.body;
  const mo = new MutationObserver(() => updateCheckoutState());
  mo.observe(observerRoot, { childList: true, subtree: true });

  ['cart:updated', 'cart:render', 'shopify:section:load', 'DOMContentLoaded'].forEach(evt => {
    document.addEventListener(evt, updateCheckoutState);
  });

  updateCheckoutState();
})();

